import { default as _91_46_46_46error_93WQNeXwcZXmMeta } from "/home/runner/work/srov-issuer-app/srov-issuer-app/pages/auth/[...error].vue?macro=true";
import { default as forgotten_45password8Q7YEoO2DrMeta } from "/home/runner/work/srov-issuer-app/srov-issuer-app/pages/auth/forgotten-password.vue?macro=true";
import { default as login1Ajf77H8tzMeta } from "/home/runner/work/srov-issuer-app/srov-issuer-app/pages/auth/login.vue?macro=true";
import { default as indexPDV1z4lHMfMeta } from "/home/runner/work/srov-issuer-app/srov-issuer-app/pages/auth/register/index.vue?macro=true";
import { default as passwordcegYTSBoMjMeta } from "/home/runner/work/srov-issuer-app/srov-issuer-app/pages/auth/register/password.vue?macro=true";
import { default as phonedUvyZaCCwvMeta } from "/home/runner/work/srov-issuer-app/srov-issuer-app/pages/auth/register/phone.vue?macro=true";
import { default as reset_45passwordpQeQs0c72LMeta } from "/home/runner/work/srov-issuer-app/srov-issuer-app/pages/auth/reset-password.vue?macro=true";
import { default as _91slug_93lQbgkQZ9vKMeta } from "/home/runner/work/srov-issuer-app/srov-issuer-app/pages/companies/[slug].vue?macro=true";
import { default as indexGyKNoB0Ke7Meta } from "/home/runner/work/srov-issuer-app/srov-issuer-app/pages/index.vue?macro=true";
import { default as _91slug_93OyP2e2seTCMeta } from "/home/runner/work/srov-issuer-app/srov-issuer-app/pages/issues/[slug].vue?macro=true";
import { default as verificationO7zanEo7JCMeta } from "/home/runner/work/srov-issuer-app/srov-issuer-app/pages/verification.vue?macro=true";
export default [
  {
    name: _91_46_46_46error_93WQNeXwcZXmMeta?.name ?? "auth-error",
    path: _91_46_46_46error_93WQNeXwcZXmMeta?.path ?? "/auth/:error(.*)*",
    meta: _91_46_46_46error_93WQNeXwcZXmMeta || {},
    alias: _91_46_46_46error_93WQNeXwcZXmMeta?.alias || [],
    redirect: _91_46_46_46error_93WQNeXwcZXmMeta?.redirect,
    component: () => import("/home/runner/work/srov-issuer-app/srov-issuer-app/pages/auth/[...error].vue").then(m => m.default || m)
  },
  {
    name: forgotten_45password8Q7YEoO2DrMeta?.name ?? "auth-forgotten-password",
    path: forgotten_45password8Q7YEoO2DrMeta?.path ?? "/auth/forgotten-password",
    meta: forgotten_45password8Q7YEoO2DrMeta || {},
    alias: forgotten_45password8Q7YEoO2DrMeta?.alias || [],
    redirect: forgotten_45password8Q7YEoO2DrMeta?.redirect,
    component: () => import("/home/runner/work/srov-issuer-app/srov-issuer-app/pages/auth/forgotten-password.vue").then(m => m.default || m)
  },
  {
    name: login1Ajf77H8tzMeta?.name ?? "auth-login",
    path: login1Ajf77H8tzMeta?.path ?? "/auth/login",
    meta: login1Ajf77H8tzMeta || {},
    alias: login1Ajf77H8tzMeta?.alias || [],
    redirect: login1Ajf77H8tzMeta?.redirect,
    component: () => import("/home/runner/work/srov-issuer-app/srov-issuer-app/pages/auth/login.vue").then(m => m.default || m)
  },
  {
    name: indexPDV1z4lHMfMeta?.name ?? "auth-register",
    path: indexPDV1z4lHMfMeta?.path ?? "/auth/register",
    meta: indexPDV1z4lHMfMeta || {},
    alias: indexPDV1z4lHMfMeta?.alias || [],
    redirect: indexPDV1z4lHMfMeta?.redirect,
    component: () => import("/home/runner/work/srov-issuer-app/srov-issuer-app/pages/auth/register/index.vue").then(m => m.default || m)
  },
  {
    name: passwordcegYTSBoMjMeta?.name ?? "auth-register-password",
    path: passwordcegYTSBoMjMeta?.path ?? "/auth/register/password",
    meta: passwordcegYTSBoMjMeta || {},
    alias: passwordcegYTSBoMjMeta?.alias || [],
    redirect: passwordcegYTSBoMjMeta?.redirect,
    component: () => import("/home/runner/work/srov-issuer-app/srov-issuer-app/pages/auth/register/password.vue").then(m => m.default || m)
  },
  {
    name: phonedUvyZaCCwvMeta?.name ?? "auth-register-phone",
    path: phonedUvyZaCCwvMeta?.path ?? "/auth/register/phone",
    meta: phonedUvyZaCCwvMeta || {},
    alias: phonedUvyZaCCwvMeta?.alias || [],
    redirect: phonedUvyZaCCwvMeta?.redirect,
    component: () => import("/home/runner/work/srov-issuer-app/srov-issuer-app/pages/auth/register/phone.vue").then(m => m.default || m)
  },
  {
    name: reset_45passwordpQeQs0c72LMeta?.name ?? "auth-reset-password",
    path: reset_45passwordpQeQs0c72LMeta?.path ?? "/auth/reset-password",
    meta: reset_45passwordpQeQs0c72LMeta || {},
    alias: reset_45passwordpQeQs0c72LMeta?.alias || [],
    redirect: reset_45passwordpQeQs0c72LMeta?.redirect,
    component: () => import("/home/runner/work/srov-issuer-app/srov-issuer-app/pages/auth/reset-password.vue").then(m => m.default || m)
  },
  {
    name: _91slug_93lQbgkQZ9vKMeta?.name ?? "companies-slug",
    path: _91slug_93lQbgkQZ9vKMeta?.path ?? "/companies/:slug()",
    meta: _91slug_93lQbgkQZ9vKMeta || {},
    alias: _91slug_93lQbgkQZ9vKMeta?.alias || [],
    redirect: _91slug_93lQbgkQZ9vKMeta?.redirect,
    component: () => import("/home/runner/work/srov-issuer-app/srov-issuer-app/pages/companies/[slug].vue").then(m => m.default || m)
  },
  {
    name: indexGyKNoB0Ke7Meta?.name ?? "index",
    path: indexGyKNoB0Ke7Meta?.path ?? "/",
    meta: indexGyKNoB0Ke7Meta || {},
    alias: indexGyKNoB0Ke7Meta?.alias || [],
    redirect: indexGyKNoB0Ke7Meta?.redirect,
    component: () => import("/home/runner/work/srov-issuer-app/srov-issuer-app/pages/index.vue").then(m => m.default || m)
  },
  {
    name: _91slug_93OyP2e2seTCMeta?.name ?? "issues-slug",
    path: _91slug_93OyP2e2seTCMeta?.path ?? "/issues/:slug()",
    meta: _91slug_93OyP2e2seTCMeta || {},
    alias: _91slug_93OyP2e2seTCMeta?.alias || [],
    redirect: _91slug_93OyP2e2seTCMeta?.redirect,
    component: () => import("/home/runner/work/srov-issuer-app/srov-issuer-app/pages/issues/[slug].vue").then(m => m.default || m)
  },
  {
    name: verificationO7zanEo7JCMeta?.name ?? "verification",
    path: verificationO7zanEo7JCMeta?.path ?? "/verification",
    meta: verificationO7zanEo7JCMeta || {},
    alias: verificationO7zanEo7JCMeta?.alias || [],
    redirect: verificationO7zanEo7JCMeta?.redirect,
    component: () => import("/home/runner/work/srov-issuer-app/srov-issuer-app/pages/verification.vue").then(m => m.default || m)
  }
]